import type { ITourPublished } from '@models/tours/ITourPublished';

/** Поиск показывается, когда список уже не осмотреть целиком. */
export const TOUR_LAUNCHER_SEARCH_THRESHOLD = 8;

const isSettledTour = (tour: ITourPublished) => {
    const status = tour.progress?.status;
    return status === 'skipped' || status === 'completed';
};

/**
 * Сначала туры, которые ещё впереди, затем пропущенные и пройденные.
 * Внутри каждой группы — по названию.
 */
const plural = (count: number, one: string, many: string) => `${count} ${count === 1 ? one : many}`;

/** Подпись под заголовком: «15 не начаты, 3 пропущены». Нулевые группы пропускаются. */
export function formatLauncherSummary(tours: readonly ITourPublished[]): string {
    let fresh = 0;
    let skipped = 0;
    let completed = 0;
    let inProgress = 0;

    for (const tour of tours) {
        const status = tour.progress?.status;
        if (status === 'skipped') skipped += 1;
        else if (status === 'completed') completed += 1;
        else if (status === 'in_progress') inProgress += 1;
        else fresh += 1;
    }

    return [
        fresh ? plural(fresh, 'не начат', 'не начаты') : '',
        inProgress ? plural(inProgress, 'в процессе', 'в процессе') : '',
        skipped ? plural(skipped, 'пропущен', 'пропущены') : '',
        completed ? plural(completed, 'пройден', 'пройдены') : '',
    ]
        .filter(Boolean)
        .join(', ');
}

export function sortLauncherTours(tours: readonly ITourPublished[]): ITourPublished[] {
    return [...tours].sort((a, b) => {
        const rankA = isSettledTour(a) ? 1 : 0;
        const rankB = isSettledTour(b) ? 1 : 0;
        if (rankA !== rankB) return rankA - rankB;
        return a.title.localeCompare(b.title, 'ru', { sensitivity: 'base' });
    });
}
